
import "./CSS/couleursActives.scss"
import couleursActivesImage from "./Assets/Couleurs_actives.svg";

export default function CouleursActives()
{
    return (
        <div className='Page'>
            <h1>Couleurs actives</h1>

            <p>
                Vous vous demandez certainement pourquoi il n'y a qu'un seul chapitre sur les couleurs.<br/>
                Dans la plupart des modes, les couleurs sont déclarées à l'envois d'un caractère à l'écran.<br/>
                Aussi, nul besoin de déclarer des couleurs en amont.
            </p>

            <p>
                Les couleurs actives n'existent que pour le mode 80 colonnes.<br/>
                Dans ce mode, vous disposez de deux couleurs actives.<br/>
                Nous y reviendront bien entendu dans les chapitres dédiés à ce mode.
            </p>

            <p>
                Pour définir ces couleurs nous utiliseront l'instruction DOR:
            </p>

            <p>
                <img className="imageCouleursActives" src={couleursActivesImage} alt="DOR couleurs actives" />
            </p>

            <p>
                Prenez bien note que selon le mode graphique utilisé, DOR n'aura pas la même signification.
            </p>

            <p>
                Voici un exemple de routine permettant de redéfinir les couleurs actives:
            </p>

            <p className="code">
                <pre>
                0| setCouls<br/>
                1|          LD     C,#8F<br/>
                2|          LD     B,#21<br/>
                3|          OUT    (C),B<br/>
                4|          SET    6,C<br/>
                5|          OUT    (C),A<br/>
                6|          RES    6,C<br/>
                7|          LD     B,#28<br/>
                8|          OUT    (C),B          ;R0+exe<br/>
                9|          SET    6,C<br/>
                10|         LD     B,%10000100<br/>
                11|         OUT    (C),B          ;DOR<br/>
                12|         CALL   wait<br/>
                13|         RET
                </pre>
            </p>

            <p>
                Vous pourrez appeler simplement cette routine en mettant dans A vos couleurs:
            </p>

            <p className="code">
                <pre>
                LD	   A,%00110010		  ;Jaune et vert<br/>
                CALL  setCouls
                </pre>
            </p>

            <p>
                Voici quelques explication:<br/>
                je définis C avec la valeur #8F correspondant au port de commande.<br/>
                Si vous faites bien attention vous vous rendrez compte que jamais je ne donne le port de données...<br/>
                L'astuce utilisée ici est de ne changer que le bit 6 pour passer de #8F à #CF.<br/>
                En effet :<br/>
                #8F = %10001111<br/>
                #CF = %11001111<br/>
                <br/>
                En faisant un SET 6,C, je mets donc le bit 6 à 1 et c'est donc bien #CF qui est dans C.<br/>
                En faisant un RES 6,C, je mets donc le bit 6 à 0 et c'est donc bien #8F qui est dans C.
            </p>

            <p>
                Le reste ne devrait pas vous poser de problème.<br/>
                Je selectionne le registre 1, je lui assigne les couleurs choisies, je met DOR dans R0 et fais un EXE.
            </p>

            <p>
                Bien évidement notre CALL wait appelle notre sous routine de test du busy de l'EF9345 comme vu dans le chapitre précédent.
            </p>

        </div>
    )
}